import React from 'react';
import styles from './index.less';

const MessageRedbookSocial = props => {
  const { data = {} } = props;
  const { image, name, title } = data;

  const showTitle = name || title;

  return (
    <div className={styles.card}>
      <div style={{ fontSize: '12px', color: '#9095AB', marginBottom: '8px' }}>邀请添加名片</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img style={{ width: '40px', height: '40px', marginRight: '10px', borderRadius: '50%' }} src={image} alt='' />
        <div style={{ fontSize: '14px', color: '#1D2754' }}>{showTitle}</div>
      </div>
    </div>
  );
};

export default MessageRedbookSocial;
